import React, { useState } from "react";
import {
    Typography,
    Button,
    Box,
    Card,
    CardContent,
    CardActions,
    Divider,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import theme from "../../../components/LayoutComponents/theme";
import { jobSkillRequest } from "../../../remote/jobRequests";
import AnalyzeCard from "./AnalyzeCard";
import DetailsCard from "./DetailsCard";
import BaseModal from "../../../components/LayoutComponents/BaseModal";

export default function JobCard({ session, job, showEditDelete, isMobile, userComp, programs, schools, courses }) {

    const [displayDetails, setDisplayDetails] = useState(false);
    const [loadingSkills, setLoadingSkills] = useState(false)
    const [jobSkills, setJobSkills] = useState([])
    const [displayAnalyze, setDisplayAnalyze] = useState(false)

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: isMobile ? "90vw" : 500,
        maxHeight: "90vh",
        overflowY: "auto",
        p: 4,
        borderRadius: 2,
    }

    const matchColor =
        Number(job.match) >= 60
            ? theme.colors.green
            : Number(job.match) >= 40
                ? theme.colors.yellow
                : "red";


    const onAnalyze = async (id) => {
        try {
            setDisplayAnalyze(true)
            setLoadingSkills(true)
            let res = await jobSkillRequest(session.token, id)
            setJobSkills(res.data || [])
        } catch (e) {
            alert('Failed to get skills for job posting ' + id + '.')
        } finally {
            setLoadingSkills(false)
        }
    }

    return (
        <>
            <Card
                sx={{
                    mx: 1,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                    transition: "all 0.2s ease-in-out",
                    "&:hover": { boxShadow: 6, transform: "translateY(-2px)" },
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography
                            variant={isMobile ? "subtitle1" : "h8"}
                            fontWeight="bold"
                            sx={{ flex: 1 }}
                        >
                            {job.title.toUpperCase()}
                        </Typography>
                        {job.isFeatured && <StarIcon sx={{ color: "gold", ml: 1 }} />}
                    </Box>

                    <Typography variant="body2" color="text.secondary">
                        {job.company}
                    </Typography>

                    {job.location && (
                        <Typography variant="body2" color="text.secondary">
                            📍 {job.location && job.location !== "" ? job.location : [job.city, job.state, job.country].filter(Boolean).join(", ")}
                        </Typography>
                    )}

                    <Box mt={1}>
                        {job.match && !isNaN(job.match) && (
                            <Typography variant="body2">
                                <strong>Match:</strong>{" "}
                                <span style={{ color: matchColor }}>{job.match}%</span>
                            </Typography>)}
                    </Box>
                </CardContent>

                <Divider />

                <CardActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: isMobile ? "wrap" : "nowrap",
                        px: 2,
                        pb: 2,
                    }}
                >
                    <Button
                        size="small"
                        sx={{ color: theme.colors.purple }}
                        onClick={() => setDisplayDetails(true)}
                    >
                        View Details
                    </Button>

                    <Button
                        size="small"
                        sx={{ color: theme.colors.purple }}
                        onClick={() => onAnalyze(job.jobPostingId)}
                        disabled={job.jobPostingId === 0?true:false}
                    >
                        Boost Your Match
                    </Button>

                    <Button
                        size="small"
                        href={job.companyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: theme.colors.purple }}
                    >
                        Apply
                    </Button>

                    {showEditDelete && (
                        <Box>
                            <Button size="small" sx={{ color: theme.colors.purple }}>
                                <EditIcon />
                            </Button>
                            <Button size="small" sx={{ color: theme.colors.purple }}>
                                <DeleteIcon />
                            </Button>
                        </Box>
                    )}
                </CardActions>
            </Card>

            {/* Modal for job analysis */}
            <BaseModal
                open={displayAnalyze}
                onClose={() => setDisplayAnalyze(false)}
                modalStyle={modalStyle}
            >
                <AnalyzeCard
                    session={session}
                    isSmallScreen={isMobile}
                    skills={jobSkills}
                    loadingSkills={loadingSkills}
                    userComp={userComp}
                    job={job}
                    programs={programs}
                    partners={schools}
                    courses={courses}
                />
            </BaseModal>

            {/* Modal for job details */}
            <BaseModal
                open={displayDetails}
                onClose={() => setDisplayDetails(false)}
                modalStyle={modalStyle}
            >
                <DetailsCard job={job} />
            </BaseModal>
        </>
    );
};
